import script from "./boardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./boardPage.vue?vue&type=script&setup=true&lang=js"

import "./boardPage.vue?vue&type=style&index=0&id=7da53ff6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7da53ff6"]])

export default __exports__